import React from 'react'

const TextPreview = ({ data }) => {
    const { text } = data

    return (
        <div dangerouslySetInnerHTML={{ __html: text?.replace(/\r?\n/g, "<br />") }} />
    )
}

export default TextPreview
